import { CallbackBody } from '@callback/const';
import { PROCESS_FEATURE, StateUtils } from '@spartacus/core';
import { CALLBACK_PROCESS_ID } from '../callback-state';

export const CALLBACK_REQUEST = '[Callback] Callback Request';
export const CALLBACK_REQUEST_SUCCESS = '[Callback] Callback Request Success';
export const CALLBACK_REQUEST_FAIL = '[Callback] Callback Request Fail';
export const CALLBACK_REQUEST_RESET = '[Callback] Callback Request Reset';

export class CallbackRequest extends StateUtils.EntityLoadAction {
  readonly type = CALLBACK_REQUEST;

  constructor(public payload: CallbackBody) {
    super(PROCESS_FEATURE, CALLBACK_PROCESS_ID);
  }
}

export class CallbackRequestFail extends StateUtils.EntityFailAction {
  readonly type = CALLBACK_REQUEST_FAIL;

  constructor(public payload: any) {
    super(PROCESS_FEATURE, CALLBACK_PROCESS_ID, payload);
  }
}

export class CallbackRequestSuccess extends StateUtils.EntitySuccessAction {
  readonly type = CALLBACK_REQUEST_SUCCESS;

  constructor(public payload: CallbackBody) {
    super(PROCESS_FEATURE, CALLBACK_PROCESS_ID, payload);
  }
}

export class CallbackRequestReset extends StateUtils.LoaderResetAction {
  readonly type = CALLBACK_REQUEST_RESET;

  constructor() {
    super(PROCESS_FEATURE);
  }
}

export type CallbackRequestAction =
  | CallbackRequest
  | CallbackRequestFail
  | CallbackRequestSuccess
  | CallbackRequestReset;
